import { CommonService, ServiceHistoryCheckModel } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_CHECK_QUERY_KEY = 'ServiceHistoryCheckQuery';

const fetchServiceHistoryCheck = async (regNo: string) => {
  const result = await CommonService.getCommonServiceHistoryCheck(regNo);
  return result;
};

export const useServiceHistoryCheckQuery = (regNo?: string, options?: { enabled?: boolean }) =>
  useQuery<ServiceHistoryCheckModel>(
    [SERVICE_HISTORY_CHECK_QUERY_KEY, regNo],
    () => {
      if (!regNo) {
        throw new Error('regNo is required');
      }
      return fetchServiceHistoryCheck(regNo);
    },
    {
      enabled: !!regNo && options?.enabled !== false
    }
  );
